export * from './angular2-pubsub.service';
export * from './angular2-pubsub.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-pubsub/esm/src/index.js
// module id = 155
// module chunks = 4